const FOCUSABLE_ELEMENTS = '[aria-invalid="true"]';
const WAIT_TIME = 150;

export const useFocusOnError = () => {
  const focusOnFirstError = () => {
    const firstErrorNode = document.querySelector(FOCUSABLE_ELEMENTS);

    if (!firstErrorNode) {
      return;
    }

    try {
      firstErrorNode.scrollIntoView({
        block: 'center',
      });

      const focusableElement = firstErrorNode as HTMLInputElement;

      setTimeout(() => {
        focusableElement.focus({ preventScroll: false });
        focusableElement.select();
      }, WAIT_TIME);
    } catch (_e) {
      firstErrorNode.scrollIntoView();
    }
  };

  return { focusOnFirstError };
};
